import React, {ReactNode, useMemo, useState} from 'react';
import {useStore} from "../../../../store/global/appStore";
import { ReactComponent as FlightIcon } from "../../../../assets/images/flight-takeoff.svg";
import { ReactComponent as FlightLandIcon } from "../../../../assets/images/flight-land.svg";
import { ReactComponent as LocationIcon } from '../../../../assets/images/location.svg';
import { ReactComponent as CircleIcon } from '../../../../assets/images/circle.svg';
import SelectRoadSearches from "../../../RouteSelectorB2C/SelectRoadSearches";
import SelectSearches from "../../../RouteSelectorB2C/SelectSearches";
import { DrawerContent, InputDisplay, InputWrapperSelector, ListContentWrapper, PrefixIconWrapper } from '../../../RouteSelectorB2C/styles';
import { Label } from '../../../CustomAntdComponents/StyledInput/styles';
import MobileBottomSheet from '../../../MobileBottomSheet/MobileBottomSheet';

type Props = {
    label: string,
    defaultValue?: string,
    onChange?: (value: any) => void;
    suffixIcon?: ReactNode,
    value?: string | number,
    icon: 'takeoff' | 'land' | 'circle' | 'location',
    tripType: 'flight' | 'road',
    mode: string,
    allowMultipleDestinations?: boolean,
    onAddMultipleDestinations?: () => void
 }

const renderIcon = (icon: string): ReactNode => {
    if (icon === 'takeoff') {
        return <FlightIcon />;
    } else if (icon === 'land') {
        return <FlightLandIcon />;
    }  else if (icon === 'location') {
        return <LocationIcon />;
    }  else if (icon === 'circle') {
        return <CircleIcon />;
    } else {
        return <FlightIcon />;
    }
}

const ModifyRouteSelector = ({ value, label, onChange, icon, tripType, mode, allowMultipleDestinations, onAddMultipleDestinations }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState("");

    const { roadRoutes, airports} = useStore();

    const displayValue = useMemo(() => {
        if(tripType === "road"){
            return roadRoutes.find((option) => option.TerminalId.toString() === value)?.TerminalName;
        }

        const airport = airports.find((option) => option.Code === value);

        if(airport){
            return `${airport.Code}, ${airport.StateName}`;
        }

        if(value) {
            return value.toString();
        }

        return '';
    }, [value, airports, roadRoutes]);

    const handleSelect = (val: any) => {
        onChange?.(val);
        setIsOpen(false);
        setSearchText("");
    }

    return (
        <div>
            <InputWrapperSelector onClick={() => setIsOpen(true)}>
                <PrefixIconWrapper>
                    {renderIcon(icon)}
                    <Label>
                        {`${label}: `}
                    </Label>
                </PrefixIconWrapper>
                <InputDisplay> {displayValue}
                </InputDisplay>
            </InputWrapperSelector>

            <MobileBottomSheet
                open={isOpen}
                onClose={() => {
                    setSearchText("");
                    setIsOpen(false);
                }}
                title={mode === "from" ? "Where are you departing from?" : "Where is your destination?"}
                className="route-selector-bottom-sheet"
                height="calc(100dvh - 68px)"
            >
                <DrawerContent className="route-selector-sheet-content">
                    <ListContentWrapper className="route-selector-list-content">
                        {
                            tripType === 'road' ? (
                                 <SelectRoadSearches
                                    onSelect={handleSelect}
                                    searchText={searchText}
                                    setSearchText={setSearchText}
                                    options={[]}
                                    mode={mode}
                                    isMobileView
                                />

                            ) : (
                                <SelectSearches
                                    onSelect={handleSelect}
                                        searchText={searchText}
                                        mode={mode}
                                        allowMultipleDestinations={allowMultipleDestinations}
                                        disabled={false}
                                        onAddMultipleDestinations={onAddMultipleDestinations}
                                        setIsOpen={setIsOpen}
                                        setSearchText={setSearchText}
                                        isMobileView
                                        showTitle={false}
                                />
                            )
                        }
                    </ListContentWrapper>
                </DrawerContent>
            </MobileBottomSheet>
        </div>
    );
};

export default ModifyRouteSelector;
